import { ResourceProps } from "@refinedev/core";
import { UserOutlined } from "@ant-design/icons";

export const commentatorsResource: ResourceProps = {
  name: "commentators",
  meta: {
    icon: <UserOutlined />,
    label: "Комментаторы",
  },
  list: "/commentators",
};
